/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdherenceReportResponseDto,
  AdherenceSummaryResponseDto,
  DailyTaskGroupDto,
  ErrorResponse,
  TodayPillarsResponseDto,
  TodayTasksResponseDto,
  UpdateDailyTaskGroupDto,
} from '../models/index';
import {
    AdherenceReportResponseDtoFromJSON,
    AdherenceReportResponseDtoToJSON,
    AdherenceSummaryResponseDtoFromJSON,
    AdherenceSummaryResponseDtoToJSON,
    DailyTaskGroupDtoFromJSON,
    DailyTaskGroupDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    TodayPillarsResponseDtoFromJSON,
    TodayPillarsResponseDtoToJSON,
    TodayTasksResponseDtoFromJSON,
    TodayTasksResponseDtoToJSON,
    UpdateDailyTaskGroupDtoFromJSON,
    UpdateDailyTaskGroupDtoToJSON,
} from '../models/index';

export interface GetAdherenceReportRequest {
    period?: GetAdherenceReportPeriodEnum;
    date?: Date;
}

export interface UpdateTodayTaskGroupRequest {
    groupId: string;
    updateDailyTaskGroupDto: UpdateDailyTaskGroupDto;
}

/**
 * 
 */
export class DashboardApi extends runtime.BaseAPI {

    /**
     * Returns the Daily, Weekly, or Monthly task-point adherence report anchored to a patient-local calendar date.
     * Get adherence report
     */
    async getAdherenceReportRaw(requestParameters: GetAdherenceReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdherenceReportResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['period'] != null) {
            queryParameters['period'] = requestParameters['period'];
        }

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dashboard/adherence-report`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdherenceReportResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns the Daily, Weekly, or Monthly task-point adherence report anchored to a patient-local calendar date.
     * Get adherence report
     */
    async getAdherenceReport(requestParameters: GetAdherenceReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdherenceReportResponseDto> {
        const response = await this.getAdherenceReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns dynamic task-point scores for today and yesterday plus rolling weekly and calendar-month averages. A complete seven-day window drops one lowest score.
     * Get dashboard adherence summary
     */
    async getAdherenceSummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdherenceSummaryResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dashboard/adherence-summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdherenceSummaryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns dynamic task-point scores for today and yesterday plus rolling weekly and calendar-month averages. A complete seven-day window drops one lowest score.
     * Get dashboard adherence summary
     */
    async getAdherenceSummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdherenceSummaryResponseDto> {
        const response = await this.getAdherenceSummaryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the authenticated patient\'s five dashboard pillars with totals derived from today\'s generated tasks.
     * Get today\'s dashboard pillars
     */
    async getTodayPillarsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TodayPillarsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dashboard/today-pillars`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TodayPillarsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns the authenticated patient\'s five dashboard pillars with totals derived from today\'s generated tasks.
     * Get today\'s dashboard pillars
     */
    async getTodayPillars(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TodayPillarsResponseDto> {
        const response = await this.getTodayPillarsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns all four time slots and their persisted generated task groups for the authenticated patient\'s local date.
     * Get today\'s dashboard tasks
     */
    async getTodayTasksRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TodayTasksResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dashboard/today-tasks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TodayTasksResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns all four time slots and their persisted generated task groups for the authenticated patient\'s local date.
     * Get today\'s dashboard tasks
     */
    async getTodayTasks(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TodayTasksResponseDto> {
        const response = await this.getTodayTasksRaw(initOverrides);
        return await response.value();
    }

    /**
     * Persists checklist selections submitted by Update, or aggregate hydration progress, for one owned task group.
     * Update a dashboard task group
     */
    async updateTodayTaskGroupRaw(requestParameters: UpdateTodayTaskGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyTaskGroupDto>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling updateTodayTaskGroup().'
            );
        }

        if (requestParameters['updateDailyTaskGroupDto'] == null) {
            throw new runtime.RequiredError(
                'updateDailyTaskGroupDto',
                'Required parameter "updateDailyTaskGroupDto" was null or undefined when calling updateTodayTaskGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dashboard/today-tasks/{groupId}`.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDailyTaskGroupDtoToJSON(requestParameters['updateDailyTaskGroupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyTaskGroupDtoFromJSON(jsonValue));
    }

    /**
     * Persists checklist selections submitted by Update, or aggregate hydration progress, for one owned task group.
     * Update a dashboard task group
     */
    async updateTodayTaskGroup(requestParameters: UpdateTodayTaskGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyTaskGroupDto> {
        const response = await this.updateTodayTaskGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetAdherenceReportPeriodEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly'
} as const;
export type GetAdherenceReportPeriodEnum = typeof GetAdherenceReportPeriodEnum[keyof typeof GetAdherenceReportPeriodEnum];
